import * as React from "react";
import { IconBase, IIconBase } from "./IconBase";

export const PackageIcon = ({ ...props }: IIconBase) => (
  <IconBase {...props}>
    <title>Package</title>
    <path d="M44,30H40V14.06L24,4.43,8,14.06V30H4v4H8.12L24,43.57,39.88,34H44ZM34.43,15.38l-3,1.82L21,10.92,24,9.1ZM24,21.67,13.57,15.38l3.54-2.13,10.43,6.28ZM12,19.11l10,6V37.7l-10-6ZM26,37.7V25.13l10-6V31.68Z" />
  </IconBase>
);
